if (document.getElementsByClassName('js-checkConf')[0]) {
  window.addEventListener('change', function (e) {
    const item = e.target.closest('.js-checkConf')
    if (!item) {
      return
    }

    const confirm = window.confirm('公開しますか？')
    if (!confirm) {
      document.querySelector('.js-checkConf--off').checked = true
    }
  })
}
